<template>
  <div>
    <div class="user-name">{{ user_name }}<span>さん</span></div>
  </div>
</template>

<script>
export default {
  name: "UserName",
  computed: {
    user_name() {
      return this.$store.state.user_name;
    },
  },
};
</script>

<style>
.user-name {
  color: white;
  font-weight: bold;
  font-size: 40px;
  float: right;
  margin: -20px 120px 0 0;
}
.user-name span {
  font-size: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/UserName.vue